import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {HTH} from "../../HTH";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {HTHSymbol} from "../../symbols/HTHSymbol";
import {HTHEnhancerSymbol} from "../../symbols/HTHEnhancerSymbol";
import {HTHSound} from "../../sound/HTHSound";

export class DropOutPresentation implements SimplePresentation {
    name: string = "DropOutPresentation";

    shouldRun(): boolean {
        return !HTH.model.isNextAvalanche;
    }

    start(controller: SimplePresentationRunnerController): void {
        const dropOutTl: gsap.core.Timeline = gsap.timeline({
            onComplete: () => {
                HTH.screenInteractive.setInteractiveState(false);
                controller.finish();
            }
        });

        controller.setSkipCallback();
        HTH.screenInteractive.setInteractiveState(true);
        HTH.screenInteractive.clickArea.on('pointerdown', () => {
            HTH.screenInteractive.setInteractiveState(false);
            dropOutTl.timeScale(2);
        });

        dropOutTl.add(() => {
            HTHSound.playTrack(HTHSound.REELS_SPIN_OUT);
            HTHSound.resetSoundStuff();
        }, 0);


        HTH.model.xNudgePositionPerReel.forEach((arr: number[]) => {
            if (arr.length > 0) {
                if (arr[0] !== 0 && arr[0] !== 5) {
                    const ebSym: HTHEnhancerSymbol = <HTHEnhancerSymbol>HTH.reelArea.getSymbol([arr[0], 3]);
                    if (!ebSym.isEnhancerOpen) {
                        ebSym.movetoParticularMaskedLayer((HTH.reelArea.allReels[arr[0]].reelView.reelLayers.maskedEffectsLayer));
                    }
                }
                const xNSym: HTHSymbol = HTH.reelArea.getSymbol(arr);
                const blSym: HTHSymbol = HTH.reelArea.getSymbol([arr[0], 0]);
                if (HTH.reelArea.allReels[xNSym.reelId].reelView.isStacked && blSym.symName !== "XN") {
                    //TODO check if XN can be put in full wild and it drops out from there
                    HTH.reelArea.allReels[xNSym.reelId].reelView.swapSymbols(xNSym, blSym);
                }
            }
        })
        HTH.model.xNudgePositionPerReel = [[], [], [], [], [], []];
        dropOutTl.add(HTH.reelArea.resetEnhancers(), 0);
        dropOutTl.add(HTH.reelArea.dropOut(HTH.model.isNextNormal), "<0.01");
        dropOutTl.add(() => {
            HTH.reelArea.playReelFireEffect()
        }, HTH.apiPlugin.settings.get(APISetting.FAST_SPIN) ? 0.1 : 0.35);
        // console.log("HI", dropOutTl.totalDuration());
        if (HTH.apiPlugin.settings.get(APISetting.FAST_SPIN)) {
            dropOutTl.timeScale(1.2);
        }

    }
}